import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Navigation from "navigation";
import useSentry from "hooks/useSentry";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // set a global default staleTime of 30 seconds to prevent
      // refetches on every window refocus
      staleTime: 1000 * 30,
    },
  },
});

const App = () => {
  useSentry();
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Navigation />
          </BrowserRouter>
        </PersistGate>
      </Provider>
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
